import { AddLoyaltyProgramState } from './addLoyaltyProgram.types'

const initialState: AddLoyaltyProgramState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
